<template>
  <div class="row animated fade-in">
    <div class="col-md-12">
      <Loader :isVisible="isLoading" />
      <StatsCommercialsV2Periods
        :defaultStat="statsCommercials"
        :form="form"
        @updateForm="updateForm"
      />
      <StatsCommercialsV2Static
        :defaultStat="staticStatsCommercials"
        :form="staticForm"
        @updateForm="updateStaticForm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loader from "@/components/utils/Loader";
import StatsCommercialsV2Periods from "@/components/stats/StatsCommercialsV2Periods";
import StatsCommercialsV2Static from "@/components/stats/StatsCommercialsV2Static";

export default {
  components: {
    Loader,
    StatsCommercialsV2Periods,
    StatsCommercialsV2Static,
  },

  data() {
    return {
      page: 1,
      isLoading: false,
      statsCommercials: [],
      staticStatsCommercials: [],
      form: {
        begin: moment().subtract(6, "month").startOf("month").toDate(),
        end: moment().endOf("month").toDate(),
      },
      staticForm: {
        month: 8,
        year: 2024,
      },
    };
  },

  methods: {
    async getStaticStatCommercials() {
      try {
        this.isLoading = true;

        this.staticStatsCommercials = [];

        const { data } = await this.$api.get("/stats/commercials-v2", {
          params: {
            month: this.staticForm.month,
            year: this.staticForm.year,
          },
        });

        this.staticStatsCommercials = data.statCommercialDatasV2.map((stat) => {
          return {
            ...stat,
            active: true,
          };
        });
      } catch (error) {
        if (error.response?.status === 404) {
          this.$errorToast("Aucune donnée disponible pour cette période");
        } else {
          this.$errorToast("Impossible de charger les statistiques");
        }
      } finally {
        this.isLoading = false;
      }
    },

    async getStatCommercials() {
      try {
        this.isLoading = true;

        this.statsCommercials = [];

        const { data } = await this.$api.get("/stats/commercials-v2/periods", {
          params: {
            begin: this.form.begin,
            end: this.form.end,
          },
        });

        this.statsCommercials = data.map((stat) => ({
          ...stat,
          active: true,
        }));
      } catch (e) {
        this.$errorToast("Impossible de charger les statistiques");
      } finally {
        this.isLoading = false;
      }
    },

    updateForm(form) {
      this.form = form;

      this.getStatCommercials();
    },

    updateStaticForm(form) {
      this.staticForm = form;

      this.getStaticStatCommercials();
    },
  },
};
</script>

<style type="text/css"></style>
